import { connectHalfEdgeWithPort } from "../connect/connectHalfEdgeWithPort.js";
import { addEdge } from "../net/addEdge.js";
import {} from "../net/index.js";
import {} from "../port/index.js";
import {} from "./HalfEdge.js";
export function halfEdgeFromPort(net, port) {
    const edge = addEdge(net);
    connectHalfEdgeWithPort(net, edge.first, port);
    return edge.second;
}
//# sourceMappingURL=halfEdgeFromPort.js.map